/**
 * Central constants file for all unique screen names used by column configurators.
 * These names are used to save/load column configuration preferences via the API.
 * Keep entries sorted alphabetically to easily verify uniqueness.
 */
export const UniqueTableNamesForColumnConfiguration = {
  AgeingAnalysis: 'ageing-analysis',
  AgeingAnalysisCustomerOutstandingTransactions: 'ageing-analysis-customer-outstanding-transactions',
  CaseDetailsTransactions: 'case-details-transactions',
  CollectionsQueue: 'collections-queue',
  Contacts: 'contacts',
  CreateCaseTransactions: 'create-case-transactions',
  CreatePromiseTransactions: 'create-promise-transactions',
  CustomerDetailAddresses: 'customer-detail-addresses',
  CustomerDetailCollections: 'customer-detail-collections',
  CustomerDetailCommunications: 'customer-detail-communications',
  CustomerDetailDisputes: 'customer-detail-disputes',
  CustomerDetailHistory: 'customer-detail-history',
  CustomerDetailOutstanding: 'customer-detail-outstanding',
  CustomerDetailPromises: 'customer-detail-promises',
  Customers: 'customers',
  DisputeDetailsTransactions: 'dispute-details-transactions',
  DisputeManagementAllDisputes: 'Dispute_Management_All_Disputes',
  PromiseDetailsTransactions: 'promise-details-transactions',
  PromiseToPay: 'PromiseToPay',
  Receipts: 'receipts',
  Transactions: 'transactions',
} as const;
